import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import { timeframeMap } from '../constants';
import { isLabelledFeedResourceEnabled } from '../get-discover-enabled-state';
import useLabelFeedPostsQuery, {
	type useLabelFeedPostsQuery as useLabelFeedPostsQueryType,
} from '../hooks/__generated__/useLabelFeedPostsQuery.graphql';
import { getTimeframe } from '../types';

export const farewellFeedResource: RouteResource<
	PreloadedQuery<useLabelFeedPostsQueryType, Record<string, unknown>>
> = createRelayResource<useLabelFeedPostsQueryType>({
	getQuery: (routerContext, resourceStoreContext) => {
		const context = resourceStoreContext as ResourceContext;

		const timeframe = getTimeframe(routerContext.query.timeGranularity);
		const isEnabled = isLabelledFeedResourceEnabled(!!context.collabContext?.rovoWorkspace);

		const cqlQuery = `label = "farewell-blog" AND created > now("${timeframeMap[timeframe]}") order by created desc`;

		return {
			query: useLabelFeedPostsQuery,
			variables: {
				cloudId: context.collabContext?.rovoWorkspace,
				cqlQuery,
				isEnabled,
			},
			environment: getAggRelayEnvironment(),
		};
	},
	maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
